export enum BlackListQryType {
  // 白名单
  WHITE = '1',
  // 黑名单
  BLACK = '0',
}

/**
 * banner - 用户包黑白名单配置，包括配置已过期/未过期banner
 * 例子:
 *  {
   // "https://prom.wechatpay.com.hk/vb-wallet-act/remittance/index.html?ADTAG=remittance"
   configBannerLink: 'vb-wallet-act/remittance',
   actListId: '234',
   qryType: BlackListQryType.BLACK,
 }
 */
export interface BlackListConfigItem {
  // 用户包id - prom_check_act_blacklist调用需要
  actListId: string;
  // 查询黑名单or白名单
  qryType: BlackListQryType;
}
